import AppStore from '../store/AppStore';

export const LangDynamicLink = (path) => {
  return `/${AppStore.ln}/${path}`;
};
